<template>
  <wo-button class="po-promise-button" :class="{'po-promise-button--loading': loading}" :type="type" :disabled="buttonDisabled" @click.native="clicked">
    <span class="po-promise-button__label">
      <slot>{{ buttonlabel }}</slot>
    </span>
    <div class="po-promise-button__spinner">
      <wo-icon icon="spinner" mod-spinning />
    </div>
  </wo-button>
</template>
<script>

export default {
  name: 'PoPromiseButton',
  props: {
    label: String,
    labelKey: String,
    disabled: Boolean,
    native: Boolean,
    type: { type: String, default: 'button' }
  },
  data () {
    return { loading: false }
  },
  computed: {
    buttonDisabled () {
      return this.disabled || this.loading
    },
    buttonlabel () {
      return this.labelKey ? this.$t(this.labelKey) : this.label
    }
  },
  methods: {
    clicked (e) {
      if (!this.native) {
        e.stopPropagation()
        e.preventDefault()
      }
      if (!this.loading && !this.disabled) {
        this.toggleLoading()
        this.$emit(e.type, this.createEvent(e))
      }
    },
    toggleLoading () {
      this.loading = !this.loading
    },
    createEvent (e) {
      return new CustomEvent(e.type, {
        detail: {
          resolve: this.toggleLoading
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .po-promise-button__label {
    position: relative;
    opacity: 1;
    transition: opacity .5s ease;
  }

  .po-promise-button__spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    visibility: hidden;
    opacity: 0;

    transition: opacity .5s ease;
  }

  .po-promise-button--loading {
    .po-promise-button__spinner {
      visibility: visible;
      opacity: 1;
    }
    .po-promise-button__label {
      opacity: 0;
    }
  }
</style>
